module.exports = __webpack_public_path__ + "static/img/indexWhite.b7f2253.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/indexWhite.png
// module id = 9OFb
// module chunks = 8